import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  dialogWidth: {
    width: '436px',
  },
  tableWrapper: {
    maxHeight: '355px',
    overflow: 'auto',
  },
  tableHeadCell: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 500,
    color: '#7f7692',
    padding: '0 15px',
    ...theme.tables.headerCell,
    height: 45,
    whiteSpace: 'nowrap',
    backgroundColor: '#F8F8F8',
  },
  tableRowCell: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 500,
    color: '#7f7692',
  },
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  titleContent: {
    paddingLeft: '24px',
    paddingRight: '24px',
    ...theme.dialogs.header,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 60,
    minHeight: 60,
    backgroundColor: '#F6F6F7',
  },
  headerTitle: {
    ...theme.dialogs.title,
  },
  iconBtnStyle: {
    width: 30,
    height: 30,
    borderRadius: 6,
    padding: 0,
  },
  dialogContent: {
    padding: '40px',
  },
  alertNameHolder: {
    display: 'flex',
    alignItems: 'baseline',
    padding: '5px',
  },
  alertName:{
    fontSize: '14px',
    fontFamily: 'Roboto',
    fontWeight: 400,
    verticalAlign: 'bottom',
  },
  alertCount: {
    fontSize: '32px',
    fontFamily: 'Roboto',
    fontWeight: 300,
    verticalAlign: 'bottom',
    marginRight: '10px',
  },
}));

export default useStyles;
